export default {
  header: 'Hulpmiddelen',
  tabs: {
    qr: 'QR',
    abv: 'ABV',
    honey: 'Honing',
    bottleSlider: 'Flesschuif',
  },
  totalLiters: 'Totale liters',
  placeholderLiters: 'Voer totale liters in',
  bottleSizes: 'Flesmaten (L)',
  adjustSlider: 'Pas de schuif aan om te zien hoeveel flessen je nodig hebt.',
};
